import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import DialogListPicker from 'ondemand/components/DialogListPicker';
import DialogListSection from 'ondemand/components/DialogListSection';
import DialogListItem from 'ondemand/components/DialogListItem';

const AgencyPicker = ({agencies, dataId, onAgencyClick, open}) => {
  const sortedAgencies = _.toArray(agencies).sort((a, b) => a.compare(b));

  const agencyNodes = _.map(sortedAgencies, agency => (
    <DialogListItem
      key={agency.agencyId}
      onClick={() => onAgencyClick(agency)}
      primaryText={<div data-id={agency.agencyId}>{agency.long_name}</div>}
    />
  ));

  return (
    <DialogListPicker open={open}>
      <div data-id={dataId} >
        <DialogListSection title="Select Your Agency" mainMenuLink>
          {agencyNodes}
        </DialogListSection>
      </div>
    </DialogListPicker>
  );
};

AgencyPicker.propTypes = {
  agencies: PropTypes.objectOf(PropTypes.object),
  dataId: PropTypes.string,
  onAgencyClick: PropTypes.func,
  open: PropTypes.bool,
};

export default AgencyPicker;



// WEBPACK FOOTER //
// ./src/ondemand/components/AgencyPickerModal.js